import watchTotaisPluviometro from './saga/totaisPluviometro';

export const dashboardPluviometroSaga = [
    watchTotaisPluviometro(),
]

export * from './actionTypes';
export * from './reducer';
export * from './service';
export * from './entity';
